// extracted by mini-css-extract-plugin
export var readonly = "_gg-1";
export var star = "_gg-0";